import {
  FloatingFormItem,
  InputDate,
  InputDecimal,
  PlanAccountsSelect,
} from '@/components/_common';
import CostCenterInfiniteSelectField from '@/components/_common/CostCenterInfiniteSelectField';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, FormInstance, InputNumber, Row } from 'antd';

type Props = {
  form: FormInstance;
};

const AccountReceivableGroupingInstallmentForm: React.FC<Props> = ({
  form,
}) => {
  const ruleRequired = useDefaultEmptyFieldError();

  return (
    <Form form={form}>
      <Row gutter={[24, 24]}>
        <Col span={24} sm={12} md={8} lg={6}>
          <FloatingFormItem
            name="totalValue"
            label="Valor total (R$)"
            rules={[ruleRequired]}
          >
            <InputDecimal disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={6}>
          <FloatingFormItem
            name="planAccountId"
            label="Plano de contas"
            rules={[ruleRequired]}
          >
            <PlanAccountsSelect
              queryFilter={{
                destination: PlanAccountDestination.Revenue,
                hierarchy: PlanAccountHierarchy.Analitical,
                active: true,
              }}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={6}>
          <FloatingFormItem name="costCenterId" label="Centro de custo">
            <CostCenterInfiniteSelectField
              queryFilter={{
                active: true,
              }}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={6}>
          <FloatingFormItem
            name="installmentsFirstDueDate"
            label="Venc. 1ª Parcela"
            rules={[ruleRequired]}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={3}>
          <FloatingFormItem
            name="quantityInstallments"
            label="Qtde. Parcelas"
            rules={[ruleRequired]}
          >
            <InputNumber style={{ width: '100%' }} min={1} />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={3}>
          <FloatingFormItem
            name="intervalDays"
            label="Intervalo (dias)"
            rules={[ruleRequired]}
          >
            <InputNumber style={{ width: '100%' }} min={1} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default AccountReceivableGroupingInstallmentForm;
